'use client';

import { ManagedUIContext } from '@contexts/ui.context';
import React, { useRef } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

export default function Providers({ children }: { children: React.ReactNode }) {
  const queryClientRef = useRef<any>();

  if (!queryClientRef.current) {
    queryClientRef.current = new QueryClient();
  }

  return (
    <QueryClientProvider client={queryClientRef.current}>
      <ManagedUIContext>{children}</ManagedUIContext>
    </QueryClientProvider>
  );
}
